import React from 'react';
import { Pie } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';

ChartJS.register(ArcElement, Tooltip, Legend);

function OffenseTypePieChart({ data }) {
  const chartData = {
    labels: data.map(d => d.offense_type),
    datasets: [{
      label: '# of Offenses',
      data: data.map(d => d.count),
      backgroundColor: [
        'rgba(202, 138, 4, 0.6)',
        'rgba(54, 162, 235, 0.6)',
        'rgba(255, 99, 132, 0.6)',
        'rgba(75, 192, 192, 0.6)',
        'rgba(153, 102, 255, 0.6)',
        'rgba(255, 159, 64, 0.6)',
      ],
    }],
  };

  return <Pie data={chartData} />;
}

export default OffenseTypePieChart;